<template>
    <v-app :class="{ 'staging-environment': isStaging, 'local-devel-environment': isLocalDevel }">
        <div v-if="isStaging" class="staging-banner">
            ⚠️ STAGING-UMGEBUNG
        </div>
        <div v-if="isLocalDevel" class="local-devel-banner">
            ⚠️ LOKALE ENTWICKLUNGSUMGEBUNG
        </div>
        
        <v-snackbar v-model="$store.state.snackbar.snackbar" :color="$store.state.snackbar.snackbarColor">
            {{ $store.state.snackbar.snackbarText }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="$store.state.snackbar.snackbar = false">
                    Schließen
                </v-btn>
            </template>
        </v-snackbar>
        <v-main>
            <appbar />

            <div v-if="isLoading" class="text-center">
                <loading :active="isLoading" :color="'#b40055'" :can-cancel="false" :is-full-page="true" />
            </div>
            <div style="z-index:0; position: relative" v-else>

                <v-container>
                    <router-view />
                </v-container>

            </div>
        </v-main>
        <v-overlay opacity=0.80 :dark="$vuetify.theme.dark" :absolute="false"
            :value="$store.state.main.menuoverlay" @click="onClickOverlay()">
            <v-sheet color="white" style="width:100%">
                <v-container>
                    <v-card flat>
                        <v-card-text>
                            <overlayMenu :category="$store.state.main.currentCategory"></overlayMenu>
                        </v-card-text></v-card>
                </v-container>
            </v-sheet>
        </v-overlay>
        <appfooter></appfooter>
    </v-app>
</template>

<script>
import loading from "vue-loading-overlay"
import appbar from "./components/appbar.vue"
import overlayMenu from "./components/overlayMenu.vue"
import appfooter from "./components/appfooter.vue"


export default {
    name: "App",
    components: {
        loading,
        appbar,
        overlayMenu,
        appfooter
    },
    data: () => ({
    }),
    methods: {
        onClickOverlay() {
            this.$store.state.main.menuoverlay = false

        },
    },
    computed: {
        isLoading() {
            return this.$store.state.auth.isAuthenticating
        },
        isStaging() {
            const hostname = window.location.hostname
            // Staging-Umgebung erkennen anhand der URL
            return hostname.includes("energyview-test") || 
                   hostname.includes("staging") || 
                   hostname.includes("-test.")
        },
        isLocalDevel() {
            const hostname = window.location.hostname
            // Staging-Umgebung erkennen anhand der URL
            return hostname.includes("localhost") || 
                   hostname.includes("127.0.0.1")
        }
    }
}
</script>
<style>
.v-overlay__content {
    width: 100%
}

.v-overlay__scrim {
    background: linear-gradient(90deg, #004ba0 0%, #281e78 100%) !important;
    opacity: 0.98;
}

.v-overlay {
    align-items: flex-start;
    z-index: 4 !important;
    top: 128px !important;
}

.v-toolbar__content {
    z-index: 1;
}

/* Main Content Area */
.v-main {
    background-color: #f2f2f3 !important;
    padding-top: 140px !important;
}

/* Extra top spacing for content below appbar */
.v-main > .v-main__wrap > div > .v-container {
    padding-top: 40px !important;
}

/* Staging-Umgebung Styles */
.staging-environment {
    background-color: #fffde7 !important;
}

.staging-environment .v-main {
    background-color: #fffde7 !important;
    padding-top: 172px !important;
}

.staging-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fac328;
    color: #22262f;
    text-align: center;
    padding: 6px 0;
    font-weight: bold;
    font-family: 'Geometria', Arial, Helvetica, sans-serif;
    font-size: 14px;
    z-index: 9999;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    height: 32px;
    line-height: 20px;
}

.staging-environment .v-app-bar {
    top: 32px !important;
    margin-top: 0 !important;
}

.staging-environment .v-navigation-drawer {
    margin-top: 32px !important;
}

.local-devel-environment {
    background-color: #e3f2fd !important;
}

.local-devel-environment .v-main {
    background-color: #e3f2fd !important;
    padding-top: 172px !important;
}

.local-devel-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #281e78;
    color: #ffffff;
    text-align: center;
    padding: 6px 0;
    font-weight: bold;
    font-family: 'Geometria', Arial, Helvetica, sans-serif;
    font-size: 14px;
    z-index: 9999;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    height: 32px;
    line-height: 20px;
}

.local-devel-environment .v-app-bar {
    top: 32px !important;
    margin-top: 0 !important;
}

.local-devel-environment .v-navigation-drawer {
    margin-top: 32px !important;
}

</style>
